import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { logout, auth } from "../firebase";
import Logo from "../assets/logo.png";
import { Link } from "react-router-dom/cjs/react-router-dom";

function Footer() {
  const [user, loading] = useAuthState(auth);
  const [isLoggedOut, setIsLoggedOut] = useState(false);

  useEffect(() => {
    if (user) {
      setIsLoggedOut(false);
    } else {
      setIsLoggedOut(true);
    }
  }, [user, loading]);

  return (
    <footer className="sb-footer">
      <div className="container">
        <div className="row g-5">

          {/* Brand column */}
          <div className="col-lg-4">
            <Link to="/" className="sb-footer-brand">
              <img src={Logo} width={28} height={26} alt="StakeBits logo" />
              StakeBits
            </Link>
            <p className="sb-footer-tagline">
              Real-time statistics and tracking for Evolution live roulette tables.
            </p>
          </div>

          {/* Links */}
          <div className="col-6 col-lg-2">
            <h6>Product</h6>
            <ul className="nav flex-column gap-1">
              <li className="nav-item">
                <Link className="nav-link" to="/tables">All tables</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/pricing">Pricing</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/about-us">About us</Link>
              </li>
            </ul>
          </div>

          <div className="col-6 col-lg-2">
            <h6>Account</h6>
            <ul className="nav flex-column gap-1">
              {isLoggedOut ? (
                <>
                  <li className="nav-item">
                    <Link className="nav-link" to="/register">Create account</Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/login">Log in</Link>
                  </li>
                </>
              ) : (
                <>
                  <li className="nav-item">
                    <Link className="nav-link" to="/tables">My account</Link>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" style={{ color: 'var(--sb-danger)', cursor: 'pointer' }} onClick={() => logout()}>
                      Log out
                    </a>
                  </li>
                </>
              )}
            </ul>
          </div>

          <div className="col-6 col-lg-2">
            <h6>Legal</h6>
            <ul className="nav flex-column gap-1">
              <li className="nav-item">
                <Link className="nav-link" to="/privacy-policy">Privacy policy</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/terms">Terms of service</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/refund-policy">Refund policy</Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="col-6 col-lg-2">
            <h6>Contact</h6>
            <ul className="nav flex-column gap-1">
              <li className="nav-item">
                <a className="nav-link" href="mailto:info@stakebits.co">
                  info@stakebits.co
                </a>
              </li>
            </ul>
          </div>

        </div>

        {/* Bottom bar */}
        <div className="sb-footer-bottom mt-5">
          <span>© 2024 StakeBits. All rights reserved.</span>
          <div className="d-flex gap-4">
            <Link to="/terms" style={{ color: 'var(--sb-text-muted)', fontSize: '0.78rem' }}>Privacy terms</Link>
            <Link to="/terms" style={{ color: 'var(--sb-text-muted)', fontSize: '0.78rem' }}>Terms &amp; conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
